import styled from "styled-components";

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 2rem;
  gap: 3rem;
  text-align: center;
`;

const Title = styled.h2`
  font-size: min(3rem, 10vw);
  font-weight: bold;
  color: #333;
  margin: 0.6rem 0 1rem 0;
  letter-spacing: -0.02em;
  line-height: 1.2;
`;

const Content = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  max-width: 560px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 20vw;
    max-width: 160px;
    min-width: 80px;
    height: auto;
    object-fit: contain;

    @media (max-width: 780px) {
      width: 35vw;
    }
  }
`;

function Inception() {
  return (
    <SectionContainer>
      <div>
        <Title>Built with Industry Leaders</Title>
      </div>

      <Content>
        Smarcuit is part of the NVIDIA Inception Program and is a NextAI
        Bootcamp graduate, giving us access to technical expertise and tools
        that help us in building next-generation solutions.
      </Content>

      <LogoRow>
        <LogoWrapper>
          <img
            src={process.env.PUBLIC_URL + "/assets/inception.svg"}
            alt="NVIDIA Inception"
          />
        </LogoWrapper>
        <LogoWrapper>
          <img
            src={process.env.PUBLIC_URL + "/assets/nextai.png"}
            alt="NextAI"
          />
        </LogoWrapper>
      </LogoRow>
    </SectionContainer>
  );
}

export default Inception;
